// @flow

import React from 'react';
import PropTypes from "prop-types";
import t from "../trans";

const propTypes = {
    children: PropTypes.string
};

const defaultProps = {
};

class T extends React.Component {
	trans(text) {
		return t(text);
	}

	render() {
		return (<span>{this.trans(this.props.children)}</span>);
	}
}

T.propTypes = propTypes;
T.defaultProps = defaultProps;

export default T;
